export const ContainerStyle = {
  // style object for base or default style
  baseStyle: {
    maxW: { base: "95%", md: "86%", lg: "75%" },
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {},
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: "",
    variant: "",
    colorScheme: "",
  },
};
